import { atom, useAtomValue } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';

type Image = {
  blurDataURL: string;
  src: string;
  placeholder?: string;
};
type Images = {
  [imgKey: string]: Image;
};
const imagesAtom = atom<Images>({});

export function useStoreImages(images: { [imgKey: string]: Image }) {
  useHydrateAtoms([[imagesAtom, images]]);
}

export function useStaticImage(
  imageKey: string,
  fallbackSrc: string
): { src: string; blurDataURL: string; placeholder?: 'blur' } {
  const staticImages = useAtomValue(imagesAtom);
  return staticImages[imageKey]
    ? { ...staticImages[imageKey], placeholder: 'blur' }
    : { src: fallbackSrc, blurDataURL: '' };
}
